import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5f403e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c5f403e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f403e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5f403e4')) {
      api.createRecord('c5f403e4', component.options)
    } else {
      api.reload('c5f403e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5f403e4&scoped=true", function () {
      api.rerender('c5f403e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attrFrom/index.vue"
export default component.exports